// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../~/@master/webinfra-frontend-components/src/components/CancelButton/CancelButton.less
// module id = 1027
// module chunks = 0